// src/routes/AppRoutes.tsx
// Plezyr Admin - Dating App Moderation Platform
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';
import LoginPage from '../pages/Login';
import RegisterPage from '../pages/Register';
import LandingPage from '../pages/LandingPage';
import Dashboard from '../pages/Dashboard';
import Settings from '../pages/Settings';
import SuperadminPage from '../pages/SuperadminPage';
import AnalyticsDashboard from '../pages/AnalyticsDashboard';
import SendOtpPage from '../pages/SendOtpPage';
import VerifyOtpPage from '../pages/VerifyOtpPage';
import ForgotPasswordPage from '../pages/ForgotPasswordPage';
import VerifyResetCodePage from '../pages/VerifyResetCodePage';
import ResetPasswordPage from '../pages/ResetPasswordPage';
import ProtectedLayout from '../components/ProtectedLayout';
import UserProfilePage from '../pages/UserProfilePage';
import Users from '../pages/Users';
import Verification from '../pages/Verification';
import Reports from '../pages/Reports';
import BlockedUsers from '../pages/BlockedUsers';

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<PublicRoute><LandingPage /></PublicRoute>} />
      <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
      <Route path="/register" element={<PublicRoute><RegisterPage /></PublicRoute>} />
      <Route path="/send-otp" element={<PublicRoute><SendOtpPage /></PublicRoute>} />
      <Route path="/verify-otp" element={<PublicRoute><VerifyOtpPage /></PublicRoute>} />
      <Route path="/forgot-password" element={<PublicRoute><ForgotPasswordPage /></PublicRoute>} />
      <Route path="/verify-reset-code" element={<PublicRoute><VerifyResetCodePage /></PublicRoute>} />
      <Route path="/reset-password" element={<PublicRoute><ResetPasswordPage /></PublicRoute>} />

      {/* Protected Routes - Plezyr Admin Moderation Platform */}
      <Route
        element={
          <PrivateRoute>
            <ProtectedLayout />
          </PrivateRoute>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/users" element={<Users />} />
        <Route path="/verification" element={<Verification />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/blocked" element={<BlockedUsers />} />
        <Route path="/analytics" element={<AnalyticsDashboard />} />
        <Route path="/superadmin" element={<SuperadminPage />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/profile/:userId" element={<UserProfilePage />} />
      </Route>

      {/* Fallback for any unmatched routes */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes;
